import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteInitiativeSonarObjectsRequest = {
	initiativeId: number;
	sonarObjectIds: Array<number>;
};

export const deleteInitiativeSonarObjects = createDeleteEndpoint<DeleteInitiativeSonarObjectsRequest>(
	(request) => `/api/v3/initiatives/${request.initiativeId}/scope`,
	{
		requestTransform: ({ sonarObjectIds }) => sonarObjectIds
	}
);
